import { inject, Injectable } from '@angular/core';
import { HttpMainService } from "../http-main.service";
import {Observable} from "rxjs";
import {
  CallResponseModel,
  ListModel, ListRequestModel,
  PaginationRequestModel
} from '@itb-monorepo/models';
import {CallRequestModel} from "@itb-monorepo/models";
import {CallStatusRequestModel} from "@itb-monorepo/models";


@Injectable()
export class CallsService {
  private _HttpMainService = inject(HttpMainService);
  baseUrl = '/support/';

  getListCalls(params: ListRequestModel): Observable<ListModel<CallResponseModel>>{
    return this._HttpMainService.get(this.baseUrl + "v1/calls" , params);
  }
  addCall(model: CallRequestModel): Observable<CallResponseModel>{
    return this._HttpMainService.post(this.baseUrl + "v1/calls", model);
  }
  getCallDetails(call_id: string): Observable<CallResponseModel>{
    return this._HttpMainService.get(`${this.baseUrl}v1/calls/${call_id}`);
  }
  updateCall(call_id: string, model: CallRequestModel): Observable<CallResponseModel> {
    return this._HttpMainService.put(`${this.baseUrl}v1/calls/${call_id}`, model);
  }
  updateCallStatus(model: CallStatusRequestModel, call_id: string): Observable<CallResponseModel> {
    return this._HttpMainService.patch(`${this.baseUrl}v1/calls/${call_id}` , model);
  }
}
